<template>
  Logging out...
</template>

<style lang="scss" scoped></style>

<script>
export default {
  name: "logout",
  mounted() {
    const store = this.$root.store;
    store.methods.apiRequest("logout").then(() => {
      const router = this.$router;

      store.methods.setLoading(false);
      store.methods.setLogin(false);
      store.methods.setLogout();

      router.push("/login");
    });
  }
};
</script>
